export default "__VITE_ASSET__fca33fe3__"